/**
 * Returns the event id for /admin/adjudication/<eventId> (trailing slash allowed),
 * or '' for any other path.
 */
export function getAdjudicationEventIdFromPath(path: string): string {
  const match = path.replace(/\/$/, '').match(/^\/admin\/adjudication\/([^/]+)$/);
  if (!match) return '';
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}
